import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-4">
          <div className="text-center max-w-md">
            <h1 className="text-2xl font-bold text-gray-800 mb-4">Something went wrong</h1>
            <p className="text-gray-600 mb-4">We apologize for the inconvenience. Please try again.</p>
            {this.state.error && (
              <p className="text-xs text-red-500 bg-red-50 p-3 rounded mb-6 text-left break-all">
                {this.state.error.toString()}
              </p>
            )}
            <div className="space-x-4">
              <button
                onClick={() => {
                  this.setState({ hasError: false, error: null });
                  window.location.reload();
                }}
                className="px-4 py-2 bg-[#1a3a5c] text-white rounded-lg hover:bg-[#1f4268]"
              >
                Reload Page
              </button>
              <a
                href="/"
                className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 inline-block"
              >
                Go Home
              </a>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
